module.exports = function() {
  return new Worker(__webpack_public_path__ + "50361cde312c8996801b.worker.js");
};